import { ValueAnswer } from '../../components/context/SurveyPageContext';

const buildValueAnswer = ({
  questionId,
  value,
}: {
  questionId: number;
  value: string | null;
}): ValueAnswer => ({
  question: { id: questionId },
  value,
});

export { buildValueAnswer };
